<template>
  <v-app>
    <AppSidebar v-model="drawer" :pending-count="pendingResolutionsCount" />
    <AppTopBar @toggle-drawer="drawer = !drawer" />

    <!-- Main Content -->
    <v-main>
      <v-container fluid class="pa-4">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { useResolutionsStore } from '@/stores'
import AppSidebar from '@/components/AppSidebar.vue'
import AppTopBar from '@/components/AppTopBar.vue'

export default {
  name: 'DashboardLayout',
  components: { AppSidebar, AppTopBar },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const authStore = useAuthStore()
    const resolutionsStore = useResolutionsStore()

    const drawer = ref(true)
    const resolutionInterval = ref(null)

    // Sidebar badge driven by the store
    const pendingResolutionsCount = computed(() => resolutionsStore.pendingVoteCount)

    onMounted(async () => {
      if (!authStore.user) {
        try {
          await authStore.getCurrentUser()
        } catch {
          router.push('/auth/login')
        }
      }

      resolutionsStore.refreshPendingVoteCount()
      resolutionInterval.value = setInterval(
        () => resolutionsStore.refreshPendingVoteCount(),
        10 * 60 * 1000
      )
    })

    onBeforeUnmount(() => {
      if (resolutionInterval.value) clearInterval(resolutionInterval.value)
    })

    watch(() => route.path, (newPath, oldPath) => {
      if (window.innerWidth < 960) drawer.value = false
      // Refresh badge whenever the user navigates to/from resolutions
      if (oldPath?.startsWith('/resolutions') || newPath?.startsWith('/resolutions')) {
        setTimeout(() => resolutionsStore.refreshPendingVoteCount(), 500)
      }
    })

    return { drawer, pendingResolutionsCount }
  }
}
</script>

